import React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { debounce } from 'lodash';

import { Button, Loader } from '@smartplatform/ui';
import store from '../../../store';
import { formatDateStr } from '../../../utils';

@observer
export default class List extends React.Component {

	@observable session = null;
	@observable error = null;
	@observable importError = null;
	@observable epzSessions = [];
	@observable name = '';
	@observable number = '';
	@observable isLoading = true;
	@observable isImporting = false;
	@observable importComplete = false;
	
	constructor(props) {
		super(props);
		this.checkExistingSession = debounce(this.checkExistingSession, 500, { leading: true, trailing: true });
		this.init();
	}
	
	init = async () => {
		const id = this.props.match.params.id;
		try {
			this.session = await store.model.Document.findById(id, {
				include: [
					{
						relation: 'refLinks',
						scope: {
							include: [
								{
									relation: 'child', // вопрос заседания
									scope: {
										include: [
											{
												relation: 'refFiles',
												scope: {
													// fields: { id: true, description: true, filesize: true, docFileId: true },
													include: ['docFile'],
													order: 'orderNum asc',
												},
											},
											{
												relation: 'refLinks',
												scope: {
													include: [
														{
															relation: 'child',
															scope: {
																include: [
																	{
																		relation: 'refFiles',
																		scope: {
																			// fields: { id: true, name: true, description: true, filesize: true, docFileId: true },
																			include: ['docFile'],
																			order: 'orderNum asc',
																		},
																	},
																	{
																		relation: 'refLinks',
																		scope: {
																			include: [
																				{
																					relation: 'child',
																					scope: {
																						include: [
																							{
																								relation: 'refFiles',
																								scope: {
																									// fields: { id: true, name: true, description: true, filesize: true, docFileId: true },
																									include: ['docFile'],
																									order: 'orderNum asc',
																								},
																							},
																						],
																					}
																				},
																			],
																			order: 'orderNum asc',
																		}
																	}
																],
															}
														},
													],
													order: 'orderNum asc',
												}
											}
										],
										order: 'orderNum asc',
									}
								}
							],
							order: 'orderNum asc',
						}
					},
				]
			});
			
			this.name = 'TEST: ' + this.session.name;
			
			if (this.session.docGroup === '0.2F161.2F169.2F16B.') {
				this.checkExistingSession();
			}
			else {
				this.error = `Заседание с таким id не найдено: ${id} (ISN_DOC: ${this.session.externalId})`;
			}
		}
		catch (e) {
			this.error = e.message;
		}
		this.isLoading = false;
	};
	
	checkExistingSession = async () => {
		this.epzSessions = await store.model.Meeting.find({
			where: {
				name: this.name,
				statusId: { neq: 3 },
			}
		});
	};
	
	onNameChange = e => {
		this.name = e.target.value;
		this.checkExistingSession();
	};
	
	onNumberChange = e => {
		this.importError = null;
		this.number = e.target.value;
	};
	
	startImport = async (questions) => {
		const number = parseInt(this.number);
		if (!number) {
			this.importError = 'Введите номер заседания!';
			return;
		}
		this.isImporting = true;
		try {
			const res = await store.model.PlenarySession.importFromSazd({
				name: this.name,
				number,
				questions,
			});
			console.log('res', res);
		}
		catch (e) {
			console.error(e);
		}
		this.isImporting = false;
		this.importComplete = true;
	};
	
	addFiles = (existingFiles, document) => {
		const newFiles = document.refFiles();
		for (let refFile of newFiles) {
			const existingFileNames = existingFiles.map(rf => rf.description);
			if (!existingFileNames.includes(refFile.description)) {
				existingFiles.push(refFile);
			}
		}
	};
	
	render() {
		if (this.isLoading) return <Loader />;
		if (this.error) return <div>Ошибка: {this.error}</div>;
		
		const questions = [];
		for (let i = 0; i < this.session.refLinks().length; i++) {
			const refLink = this.session.refLinks()[i];
			if (!refLink.child) continue;
			
			const refFiles = [];

			if (refLink.child) {
				this.addFiles(refFiles, refLink.child);
				for (let _refLink of refLink.child.refLinks()) {
					if (_refLink.child) {
						this.addFiles(refFiles, _refLink.child);
						for (let __refLink of _refLink.child.refLinks()) {
							if (__refLink.child) {
								this.addFiles(refFiles, __refLink.child);
							}
						}
					}
				}
			}
			const filtered = refFiles.filter(file => !!file.docFile);
			const files = filtered.map((f, i) => ({
				id: f.docFile.id,
				num: i + 1,
				name: f.docFile.contents,
				ext: f.docFile.fileExtension,
				url: f.docFile.downloadFile('contents')
			}));
			
			questions.push({
				id: refLink.child.id,
				num: i + 1,
				name: refLink.child.name,
				files,
			});
		}
		
		console.log('questions', questions);
		
		const canImport = questions.length > 0 && !this.isImporting && this.epzSessions.length === 0 && !this.importComplete;
		
		return <div>
			<div className="block">
				<textarea value={this.name} onChange={this.onNameChange} rows={3} disabled={this.isImporting || this.importComplete} />
			</div>
			<div className="block">
				Номер заседания: <input size={4} value={this.number} onChange={this.onNumberChange} disabled={this.isImporting || this.importComplete} />
			</div>
			<div className="submit">
				<Button onClick={() => this.startImport(questions)} className="btn-primary" disabled={!canImport}>Импорт</Button>
				{this.epzSessions.length > 0 && <span className="warn"> Заседание с таким названием существует!</span>}
				{this.importError && <span className="warn"> {this.importError}</span>}
				{this.isImporting && <span> <Loader size={18} /> Идет импорт...</span>}
				{this.importComplete && <span> Импорт завершен.</span>}
			</div>
			<br />
			<div>{formatDateStr(this.session.date)}</div>
			<div className="sazd-questions">
				{questions.map(question => {
					return <div key={question.id}>
						<div className="name"><strong>{question.num}.</strong> {question.name}</div>
						<div className="files">
							{question.files.map(file => <div key={file.id}>
								<a target="_blank" href={file.url}>{file.name}</a>{' '}
								{/*<a target="_blank" href={'https://iltumen.ru' + file.url}>{file.name}</a>{' '}*/}
							</div>)}
						</div>
					</div>
				})}
			</div>
		</div>;
	}
	
}
